const _dbStorage = indexedDB
let dbObjects = new Map();
const tableNames = ['annotation', 'volume', 'mesh']
const tableNames2 = ['layerName']
let db:any
const debugg = false

export class DbStorage{
  openRequest: any;
  constructor(public dbName: string, public tableNames: string[]) {
  }
  init(dbName: string) {
    return new Promise((suc, fail) => {
    this.dbName = dbName
    if (!_dbStorage) {
      console.log('浏览器不支持indexedDb！')
    }
    // 存在就打开 不存在新建 第二个参数为db 版本
    this.openRequest = _dbStorage.open(dbName);
    // 新的数据库创建 或者数据库的版本号被更改会被触发
    this.openRequest.onupgradeneeded = (e:any) => {
      // 表的创建在这个回调里执行
      const thisDb = e.target.result;
      for (let i = 0; i < this.tableNames.length; i++) {
        const _tableName = this.tableNames[i]
        if (!thisDb.objectStoreNames.contains(_tableName)) {
          // keyPath 主键 autoIncrement 是否自增
          const objectStore = thisDb.createObjectStore(_tableName, {
              keyPath: 'name',
              // autoIncrement: true,
          });
          // 创建表的时候 可以去指定那些字段是可以被索引的字段
          objectStore.createIndex('name', 'name', { unique: false });
        }
      }
      suc(true);
    };
    // 已经创建好的数据库创建成功的时候
    this.openRequest.onsuccess = (e:any) => {
        if (!dbObjects.get(dbName)) {
          dbObjects.set(dbName, e.target.result)
        }
        const db = dbObjects.get(dbName);
        suc(db);
        db.onerror = function (event:any) {
          console.error('Database error: ' + event.target.errorCode);
          console.dir(event.target);
          fail();
        };
    };
    // 打开失败时调用
    this.openRequest.onerror = (e: any) => {
        console.error('openRequest.onerror', e);
        fail();
    };
    })
  }
  clearTable(tableName: string) {
    return new Promise(async (suc: Function, fail: Function) => {
      await this.tryOpenDb()
      const objectStore = db
        .transaction([tableName], 'readwrite')
        .objectStore(tableName);
      const request = objectStore.clear();
  
      request.onerror = function (event:Event) {
        if (debugg) console.log('事务失败', event);
        fail();
      };
  
      request.onsuccess = function (event:Event) {
        if (debugg) console.log('清除成功', event);
        suc();
      };
    });
  }
  deleteDB(dbName: string) {
    return _dbStorage.deleteDatabase(dbName);
  }
  readByIndex(tableName: string, indexName: string, indexVal: any) {
    return new Promise(async (suc, fail) => {
      await this.tryOpenDb()
      const objectStore = db
        .transaction([tableName], 'readwrite')
        .objectStore(tableName);
      // 假定新建表格的时候，对name字段建立了索引。
      // objectStore.createIndex('name', 'name', { unique: false });
  
      const index = objectStore.index(indexName);
      const request = index.get(indexVal);
      request.onerror = function () {
        if (debugg) console.log('事务失败', event);
        fail();
      };
  
      request.onsuccess = function () {
        suc(request.result);
      };
    });
  }
  async tryOpenDb () {
    if (!db) {
      await this.init(this.dbName)
      db = dbObjects.get(this.dbName)
    }
  }
  update(tableName:string, data:any) {
    return new Promise(async (suc: Function, fail: Function) => {
      await this.tryOpenDb()
      const objectStore = db
        .transaction([tableName], 'readwrite')
        .objectStore(tableName);
      const request = objectStore.put(data);
  
      request.onerror = function () {
        if (debugg) console.log('事务失败', event);
        fail();
      };
  
      request.onsuccess = function () {
        if (debugg) console.log('更新成功', event);
        suc();
      };
    });
  }
  remove(tableName: string, key:any) {
    return new Promise(async (suc:Function, fail: Function) => {
      await this.tryOpenDb()
      const objectStore = db
        .transaction([tableName], 'readwrite')
        .objectStore(tableName);
      const request = objectStore.delete(key);
  
      request.onerror = function () {
        if (debugg) console.log('删除事务失败', event);
        fail();
      };
  
      request.onsuccess = function () {
        if (debugg) console.log('删除成功', event);
        suc();
      };
    });
  }
  readByMainKey(tableName:string, key:any) {
    return new Promise(async (suc, fail) => {
      await this.tryOpenDb()
      const objectStore = db
        .transaction([tableName], 'readwrite')
        .objectStore(tableName);
      const request = objectStore.get(key);
  
      request.onerror = function (event: Event) {
        if (debugg) console.log('读取事务失败', event);
        fail();
      };
  
      request.onsuccess = function () {
        suc(request.result || {});
      };
    });
  }
  readAll(tableName:string) {
    return new Promise(async (suc, fail) => {
      await this.tryOpenDb()
      const objectStore = db
        .transaction([tableName], 'readwrite')
        .objectStore(tableName);
      const request = objectStore.getAll();
  
      request.onerror = function (event:Event) {
        if (debugg) console.log('事务失败', event);
        fail();
      };
  
      request.onsuccess = function () {
        suc(request.result || []);
      };
    });
  }
  loopAll(tableName:string) {
    return new Promise(async (suc, fail) => {
      await this.tryOpenDb()
      const objectStore = db
        .transaction([tableName], 'readwrite')
        .objectStore(tableName);
      // 我这里做的是把所有的结果全部收集起来 当然我们可以做其他事情此处拿到的value是每条数据的结果、还有primaryKey主键、key、与direction
      const result: Array<any> = [];
      objectStore.openCursor().onsuccess = function (event: any) {
        const cursor = event?.target.result;
        if (cursor) {
          result.push({ ...cursor.value });
          cursor.continue();
        } else {
          suc(result);
        }
      };
      objectStore.openCursor().onerror = function (event:any) {
        console.dir(event);
        fail();
      };
    });
  }
  add(tableName:string, data:any) {
    return new Promise(async (suc: Function, fail: Function) => {
      await this.tryOpenDb()
      const request = db
        .transaction([tableName], 'readwrite')
        .objectStore(tableName)
        .add(data);
  
      request.onsuccess = function (event: Event) {
        if (debugg) console.log('数据写入成功', event);
        suc();
      };
  
      request.onerror = function (event: Event) {
        if (debugg) console.log('数据写入失败', event);
        fail();
      };
    });
  }
}

export const dbStorage:DbStorage = new DbStorage('dataStorage', tableNames)
dbStorage.init('dataStorage');
export const dbStorageMoreWindow:DbStorage = new DbStorage('moreWindow', tableNames2)
dbStorageMoreWindow.init('moreWindow');